import React, { createContext, useEffect, useState } from 'react';
import { changePassword as requestPasswordChange, loginUser, logoutUser } from '../api';
import { getLoginRedirectPath } from '../auth/routing';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');

    if (token && storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error('Failed to parse user data', error);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
    setIsLoading(false);
  }, []);

  const login = async (userID, password) => {
    try {
      const data = await loginUser({ userID, password });
      const nextUser = {
        name: data.name,
        role: data.role,
        companyID: data.companyID,
        redirectPath: data.redirectPath,
        isFirstLogin: Boolean(data.isFirstLogin),
      };
      setUser(nextUser);
      return data.redirectPath || getLoginRedirectPath(nextUser);
    } catch (error) {
      console.error('Login failed', error);
      throw error;
    }
  };

  const changePassword = async (currentPassword, newPassword) => {
    await requestPasswordChange(currentPassword, newPassword);
    setUser((currentUser) => {
      const updatedUser = { ...currentUser, isFirstLogin: false };
      localStorage.setItem('user', JSON.stringify(updatedUser));
      return updatedUser;
    });
  };

  const logout = () => {
    logoutUser();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, isLoading, login, logout, changePassword, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};
